/** Brief 12, `Vazifalar`. */
export const uzB12Tasks = {
  "tasks.title": "Vazifalar",
  "tasks.head.overdue": "{count} kechikkan",
  "tasks.head.today": "{count} bugun",
  "tasks.head.open": "{count} ochiq",
  "tasks.scope.label": "Kimning vazifalari",
  "tasks.scope.mine": "Mening",
  "tasks.scope.allBranches": "Barcha filiallar",
  "tasks.scope.branch": "Filial",
  "tasks.new": "Vazifa",
  "tasks.chips.label": "Vazifa turi",
  "tasks.chip.all": "Hammasi",
  "tasks.chip.call": "Qo'ng'iroq",
  "tasks.chip.message": "Xabar",
  "tasks.chip.document": "Hujjat",
  "tasks.chip.payment": "To'lov",
  "tasks.chip.followUp": "Qayta aloqa",
  "tasks.chip.ai": "Kapitan AI",
  "tasks.kind.other": "Boshqa",
  "tasks.showDone": "Bajarilganlar",
  "tasks.group.overdue": "Kechikkan",
  "tasks.group.today": "Bugun",
  "tasks.group.tomorrow": "Ertaga",
  "tasks.group.later": "Keyinroq",
  "tasks.group.done": "Bajarilgan",
  "tasks.group.cancelled": "Bekor qilingan",
  "tasks.due.yesterday": "Kecha",
  "tasks.due.today": "Bugun",
  "tasks.due.tomorrow": "Ertaga",
  "tasks.origin.booking": "Bronlar · to'lov muddati",
  "tasks.origin.thread": "Suhbatlar",
  "tasks.origin.rule": "Eslatma qoidasi",
  "tasks.origin.note": "Izoh bor",
  "tasks.tick": "Bajarildi deb belgilash",
  "tasks.closedTick": "Yopilgan vazifa qayta ochilmaydi",
  "tasks.doneToast": "Bajarildi: {title}",
  "tasks.failed": "Vazifani yopib bo'lmadi: {reason}",
  "tasks.edit.save": "Saqlash",
  "tasks.edit.cancelTask": "Vazifani bekor qilish",
  "tasks.edit.saved": "Vazifa saqlandi",
  "tasks.edit.failed": "Vazifani saqlab bo'lmadi",
  "tasks.edit.pastDue": "Yangi muddat hozirgi vaqtdan keyin bo'lishi kerak.",
  "tasks.cancel.title": "Vazifani bekor qilish",
  "tasks.cancel.reason": "Sabab",
  "tasks.cancel.close": "Yopish",
  "tasks.cancel.confirm": "Bekor qilish",
  "tasks.cancel.failed": "Vazifani bekor qilib bo'lmadi",
  "tasks.empty.title": "Vazifa yo'q",
  "tasks.empty.message": "Bugungi ishlar bajarildi. Yangi vazifa bitim, suhbat yoki eslatma qoidasidan tushadi.",
  "tasks.empty.action": "Bitimlarga",
  "tasks.filterEmpty.title": "Bugun hammasi bajarildi",
  "tasks.filterEmpty.message": "Bu filtrda ochiq vazifa qolmadi.",
  "tasks.filterEmpty.action": "Filtrni tozalash",
  "tasks.error.title": "Vazifalar yuklanmadi",
  "tasks.error.message": "Server javob bermadi. Kiritgan ma'lumotlaringiz saqlangan, sahifani qayta yuklash xavfsiz.",
  "tasks.error.status": "Tizim holati",
  "tasks.denied.message": "Bu rol vazifalarni ko'rmaydi. Kerak bo'lsa, agentlik egasiga yozing.",
  "tasks.truncated": "Eng yaqin {count} ta vazifa ko'rsatildi. Ro'yxatni tur yoki filial bilan toraytiring.",
  "tasks.form.title": "Yangi vazifa",
  "tasks.form.text": "Nima qilish kerak",
  "tasks.form.textHint": "Masalan, Malikaga qo'ng'iroq qilish",
  "tasks.form.textRequired": "Vazifa matnini kiriting",
  "tasks.form.type": "Turi",
  "tasks.form.date": "Sana",
  "tasks.form.time": "Soat",
  "tasks.form.subject": "Mijoz yoki bitim",
  "tasks.form.subjectHint": "Ism yoki №",
  "tasks.form.assignee": "Mas'ul",
  "tasks.form.note": "Izoh",
  "tasks.form.noteHint": "Masalan, kechqurun qo'ng'iroq qilishni so'radi",
  "tasks.form.cancel": "Bekor qilish",
  "tasks.form.save": "Saqlash",
  "tasks.form.added": "Vazifa qo'shildi",
  "tasks.form.failed": "Vazifani qo'shib bo'lmadi",
} as const;
